import type { TrainingItemVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrieveAllTrainingItems = createApiThunk<TrainingItemVM[], void>(
  "trainingItems/studentRetrieveAllTrainingItems",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllTrainingItems();
  },
);
